module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName2),
      callback: function($$v) {
        _vm.activeName2 = $$v
      },
      expression: "activeName2"
    }
  }, [_c('el-tab-pane', {
    key: 'first',
    attrs: {
      "label": "折线统计",
      "name": "first"
    }
  }, [(_vm.firstisRouterAlive) ? _c('child1') : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    key: 'second',
    attrs: {
      "label": "表格报表",
      "name": "second"
    }
  }, [(_vm.secondisRouterAlive) ? _c('child2') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af4e6a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ShopManagement/CustomerType.vue
// module id = 1345
// module chunks = 1